import 'core-js/es/object';
import 'core-js/es/array';
import 'core-js/actual/url';
import 'core-js/actual/url-search-params';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import '../build/index.css';

import { store as generalStore } from './redux/store';
import { router } from './router';

const AppWithStore: React.FC = () => (
  <Provider store={generalStore}>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  </Provider>
);

const container = document.getElementById('app');

if (!container) {
  throw new Error('App root element not found');
}

const root = createRoot(container);

root.render(<AppWithStore />);
